export function cookieInfo() {
    const cookie = $('.cookies-holder');
    const closeCookie = cookie.find('.close-cookies');


    if (document.cookie.indexOf("cookieAccess=") >= 0) {
        cookie.hide();
    } else {
        cookie.addClass("show");
    }

    closeCookie.on("click", function (e) {
        e.preventDefault();
        let expiry = new Date();
        expiry.setTime(expiry.getTime() + (360 * 24 * 60 * 60 * 1000));
        document.cookie = "cookieAccess=yes; path=/; expires=" + expiry.toGMTString();
        cookie.removeClass("show");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/cookieInfo.js